import './main.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import { OBJLoader } from 'three/examples/jsm/loaders/OBJLoader.js';
import { Water } from 'three/examples/jsm/objects/Water2.js';
import { RectAreaLightUniformsLib } from 'three/examples/jsm/lights/RectAreaLightUniformsLib';
import { RectAreaLightHelper } from 'three/examples/jsm/helpers/RectAreaLightHelper';

let scene, camera, renderer, water, object, clock;

let light1, light2, light3, light4;

let rotatingObj, palm, tower, env2ObjLoaded, randomObj;

let hearts = [];

const container = document.querySelector('#container');

init();
animate();

function init() {
    // scene
    scene = new THREE.Scene()

    clock = new THREE.Clock();
    scene.fog = new THREE.Fog( 0xffffff, 0, 750 );

    const getRandomArbitrary = (min, max) => {
        return Math.random() * (max - min) + min;
    }

    // load OBJ functions
    function loadModelGirl() {
        object.traverse( function ( child ) {
            if ( child.isMesh ) child.material.map = texture;
        } );

        object.position.y = -2;
        object.scale.set( 3.0, 3.0, 3.0 );
        scene.add( object );
    }

    function loadModelIceCream() {
        rotatingObj.traverse( function ( child ) {
            if ( child.isMesh ) child.material = new THREE.MeshNormalMaterial();
        } );

        rotatingObj.position.y = 1;
        rotatingObj.scale.set( 0.06, 0.06, 0.06 );
        scene.add( rotatingObj );
    }

    function loadPalm() {
        palm.traverse( function ( child ) {
            if ( child.isMesh ) child.material = new THREE.MeshNormalMaterial();
        } );

        palm.position.y = -5;
        palm.position.x = 10;
        palm.position.z = -15;
        palm.scale.set( 0.8, 0.8, 0.8 );
        scene.add( palm );
    }

    function loadTower() {
        tower.traverse( function ( child ) {
            if ( child.isMesh ) child.material = new THREE.MeshNormalMaterial();;
        } );

        tower.position.y = -5;
        tower.position.x = -20;
        tower.scale.set( 1.2, 1.2, 1.2 );
        scene.add( tower );
    }

    function loadEnv2() {
        env2ObjLoaded.traverse( function ( child ) {
            if ( child.isMesh ) child.material = new THREE.MeshNormalMaterial();;
        } );

        env2ObjLoaded.position.y = -5;
        env2ObjLoaded.position.x = 15;
        env2ObjLoaded.position.z = 10;
        env2ObjLoaded.scale.set( 5, 5, 5 );
        scene.add( env2ObjLoaded );
    }

    function loadRandom() {
        randomObj.traverse( function ( child ) {
            if ( child.isMesh ) child.material = new THREE.MeshNormalMaterial();;
        } );

        randomObj.position.y = -5;
        randomObj.position.x = -20;
        randomObj.scale.set( 1.2, 1.2, 1.2 );
        scene.add( randomObj );
    }

    var onProgress = function ( xhr ) {
        if ( xhr.lengthComputable ) {
            var percentComplete = xhr.loaded / xhr.total * 100;
            var percentRounded = Math.round(percentComplete, 2)
            if (percentRounded == 100) {
                container.classList.remove('loading')
            }
        }
    };

    var onProgress2 = function ( xhr ) {
        if ( xhr.lengthComputable ) {
            var percentComplete = xhr.loaded / xhr.total * 100;
            var percentRounded = Math.round(percentComplete, 2)
            if (percentRounded == 100) {
                container.classList.remove('loading2')
            }
        }
    };

    var onProgress3 = function ( xhr ) {
        if ( xhr.lengthComputable ) {
            var percentComplete = xhr.loaded / xhr.total * 100;
            var percentRounded = Math.round(percentComplete, 2)
            if (percentRounded == 100) {
                container.classList.remove('loading3')
            }
        }
    };

    var onProgress4 = function ( xhr ) {
        if ( xhr.lengthComputable ) {
            var percentComplete = xhr.loaded / xhr.total * 100;
            var percentRounded = Math.round(percentComplete, 2)
            if (percentRounded == 100) {
                container.classList.remove('loading4')
            }
        }
    };

    var onProgress5 = function ( xhr ) {
        if ( xhr.lengthComputable ) {
            var percentComplete = xhr.loaded / xhr.total * 100;
            var percentRounded = Math.round(percentComplete, 2)
            if (percentRounded == 100) {
                container.classList.remove('loading5')
            }
        }
    };

    var onProgress6 = function ( xhr ) {
        if ( xhr.lengthComputable ) {
            var percentComplete = xhr.loaded / xhr.total * 100;
            var percentRounded = Math.round(percentComplete, 2)
            if (percentRounded == 100) {
                container.classList.remove('loading6')
            }
        }
    };

    var onProgress7 = function ( xhr ) {
        if ( xhr.lengthComputable ) {
            var percentComplete = xhr.loaded / xhr.total * 100;
            var percentRounded = Math.round(percentComplete, 2)
            console.log( percentRounded + '% downloaded' );
            if (percentRounded == 100) {
                container.classList.remove('loading9')
            }
        }
    };

    function onError() {
        console.log("loading model error")
    }

    // loading managers

    const managerHeart = new THREE.LoadingManager();
    managerHeart.onProgress = function ( item, loaded, total ) {
        console.log( "loading: " + item, loaded, total );
    };

    const managerGirl = new THREE.LoadingManager( loadModelGirl );
    managerGirl.onProgress2 = function ( item, loaded, total ) {
        console.log( "loading: " + item, loaded, total );
    };

    const managerIceCream = new THREE.LoadingManager( loadModelIceCream );
    managerIceCream.onProgress3 = function ( item, loaded, total ) {
        console.log( "loading: " + item, loaded, total );
    };

    const managerPalm = new THREE.LoadingManager( loadPalm );
    managerPalm.onProgress4 = function ( item, loaded, total ) {
        console.log( "loading: " + item, loaded, total );
    };

    const managerTower = new THREE.LoadingManager( loadTower );
    managerTower.onProgress5 = function ( item, loaded, total ) {
        console.log( "loading: " + item, loaded, total );
    };

    const managerEnv2 = new THREE.LoadingManager( loadEnv2 );
    managerEnv2.onProgress6 = function ( item, loaded, total ) {
        console.log( "loading: " + item, loaded, total );
    };

    const managerRandom = new THREE.LoadingManager( loadRandom );
    managerRandom.onProgress7 = function ( item, loaded, total ) {
        console.log( "loading: " + item, loaded, total );
    };

    // OBJ loaders
    const loaderHeart = new OBJLoader(managerHeart);
    const loaderGirl = new OBJLoader( managerGirl );
    const loaderIceCream = new OBJLoader( managerIceCream );
    const loaderPalm = new OBJLoader( managerPalm );
    const loaderTower = new OBJLoader( managerTower );
    const loaderEnv2 = new OBJLoader( managerEnv2 );
    const loaderRandom = new OBJLoader( managerRandom );

    // // load girl OBJ
    const girlObj = ['girl1'];
    const girlObjRandom = girlObj[Math.floor(fxrand() * girlObj.length)];
    
    loaderGirl.load( './obj/girl/' + girlObjRandom + '.obj', function ( obj ) {
        obj.traverse(function(child) {
        if (child instanceof THREE.Mesh) {
            child.material = metalMaterial;
        }
    });
        object = obj;
        //obj.rotation.y = Math.floor(fxrand() * 360);
    }, onProgress, onError );

    // // load floating OBJ
    const floatingObj = ['virus', 'hearts', 'stars', 'birds', 'clouds'];
    const floatingObjRandom = floatingObj[Math.floor(fxrand() * floatingObj.length)];

    for ( var i = 0; i < 100; i ++ ) {
        loaderHeart.load("./obj/sky/" + floatingObjRandom + ".obj", function(object) {
            object.traverse(function(child) {
            if (child instanceof THREE.Mesh) {
                child.material = materialGlow;
            }
        });
            let obj = object;

            obj.scale.set(10,10,10);
            obj.position.x = Math.floor( Math.random() * 15 - 10 ) * 15;
            obj.position.y = Math.floor( Math.random() * 15 ) * 15 + 10;
            obj.position.z = Math.floor( Math.random() * 15 - 10 ) * 15;

            scene.add(obj);
            hearts.push(obj);
        }, onProgress2, onError);
    }

    // // load env OBJ
    const envObj = ['bus-stop', 'electrical-towers', 'bus', 'home', 'control-house', 'coffee-shop', 'airplane'];
    const envObjRandom = envObj[Math.floor(fxrand() * envObj.length)];

    loaderTower.load( './obj/street/' + envObjRandom + '.obj', function ( obj ) {
        tower = obj;
        obj.traverse(function(child) {
    });
    }, onProgress3, onError );

    // // load plant OBJ
    const plantObj = ['lily-pond', 'cherry-blossoms', 'backyard', 'tulips', 'cacti', 'palms', 'mushrooms', 'candy-land'];
    const plantObjRandom = plantObj[Math.floor(fxrand() * plantObj.length)];

    loaderPalm.load( './obj/plants/' + plantObjRandom + '.obj', function ( obj ) {
        palm = obj;
    }, onProgress4, onError );

    // // load head OBJ
    const headObj = ['icecream', 'dna', 'popsicle', 'cupcake', 'cellphone', 'lipstick', 'wings', 'sword', 'sparkles', 'wallet'];
    const headObjRandom = headObj[Math.floor(fxrand() * headObj.length)];

    loaderIceCream.load( './obj/floating/' + headObjRandom + '.obj', function ( obj ) {
        rotatingObj = obj;
    }, onProgress5, onError );

    // // load leisure
    const env2Obj = ['gazebo', 'arcade', 'boat', 'radio', 'bridge', 'shopping-cart', 'gas-station', 'slide', 'tv'];
    const env2ObjRandom = env2Obj[Math.floor(fxrand() * env2Obj.length)];

    loaderEnv2.load( './obj/leisure/' + env2ObjRandom + '.obj', function ( obj ) {
        env2ObjLoaded = obj;
    }, onProgress6, onError );

    // // load random
    const randomObjArray = ['car', 'cat', 'magic-rabbit', 'USB', 'traffic-lights', 'llama', 'wind-turbines', 'crocodile', 'seashell'];
    const randomObjRandom = randomObjArray[Math.floor(fxrand() * randomObjArray.length)];

    loaderRandom.load( './obj/random/' + randomObjRandom + '.obj', function ( obj ) {
        randomObj = obj;
    }, onProgress7, onError );

    // camera
    camera = new THREE.PerspectiveCamera( 45, window.innerWidth / window.innerHeight, 0.1, 400 );
    camera.position.set( 6, 0, 15 );
    camera.lookAt( scene.position );

    const managerTexture = new THREE.LoadingManager();
    managerTexture.onProgress = function ( url, itemsLoaded, itemsTotal ) {
        console.log( 'Loading texture file: ' + url + '.\nLoaded ' + itemsLoaded + ' of ' + itemsTotal + ' files.' );
    };

    managerTexture.onLoad = function () {
        container.classList.remove("loading7");
    }

    const managerTexture2 = new THREE.LoadingManager();
    managerTexture2.onLoad = function () {
        container.classList.remove("loading8");
    }

    // texture
    const textureLoader = new THREE.TextureLoader(managerTexture2);
    const texture = textureLoader.load('./textures/uv_grid_opengl.jpg');

    // materials

    const metalMaterial = new THREE.MeshStandardMaterial( {
        envMap: texture,
        color: 0xffffff,
        roughness: 0.1,
        metalness: 0.3,
        side: THREE.DoubleSide,
        wireframe: false
    } );

    var materialGlow = new THREE.ShaderMaterial({
    uniforms: {
            "c":   { type: "f", value: 2.0 },
            "p":   { type: "f", value: 2.0 },
            glowColor: { type: "c", value: new THREE.Color(0xFF1493) },
            viewVector: { type: "v3", value: camera.position }
        },
        vertexShader:   document.getElementById( 'vertexShader' ).textContent,
        fragmentShader: document.getElementById( 'fragmentShader' ).textContent,
        side: THREE.FrontSide,
        blending: THREE.AdditiveBlending,
        transparent: true
    });

    // ground
    const groundGeometry = new THREE.PlaneGeometry( 50, 50 );
    const groundMaterial = new THREE.MeshStandardMaterial( { roughness: 1.0, metalness: 0.2 } );
    const ground = new THREE.Mesh( groundGeometry, groundMaterial );
    ground.rotation.x = Math.PI * - 0.5;
    ground.position.y = -5
    scene.add( ground );

    // water
    const waterGeometry = new THREE.PlaneGeometry( 50, 50 );

    water = new Water( waterGeometry, {
        color: '#ffffff',
        scale: Math.floor(Math.random() * 4) + 1,
        flowDirection: new THREE.Vector2(-1, 1),
        textureWidth: 1024,
        textureHeight: 1024
    } );

    water.position.y = -2;
    water.rotation.x = Math.PI * - 0.5;
    scene.add( water );

    // env light
    const ambientLight = new THREE.AmbientLight( 0xcccccc, 0.01 );
    scene.add( ambientLight );

    // const directionalLight = new THREE.DirectionalLight( 0xffffff, 0.1 );
    // directionalLight.position.set( - 1, 1, 1 );
    // scene.add( directionalLight );

    // point lights
    const colors = ['97a7ff', 'fc7edc', '886bfa', 'E0B0FF', 'bd82f9', 'f69bd7', 'a19ff9', 'fd90ff', '7388f6', '7e62db', 'b185e2'];

    var colorsIndex = [];
    for (let i = 0; i < colors.length; i++) {
        var r = Math.floor(fxrand() * colors.length);
        if(colorsIndex.indexOf(r) === -1) colorsIndex.push(r);
    }

    let colors0 = colorsIndex[0];
    let colors1 = colorsIndex[1];

    const color = new THREE.Color();
    const colorsRandom = `0x${colors[colors0]}`;
    const colorsRandom2 = `0x${colors[colors1]}`;
    
    const sphere = new THREE.SphereGeometry( 0.5, 16, 8 );

    light1 = new THREE.PointLight( color.setHex(colorsRandom), 5, 20 );
    light1.add( new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( { color: color.setHex(colorsRandom) } ) ) );
    scene.add( light1 );

    light2 = new THREE.PointLight( color.setHex(colorsRandom2), 5, 20 );
    light2.add( new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( { color: color.setHex(colorsRandom2) } ) ) );
    scene.add( light2 );

    light3 = new THREE.PointLight( color.setHex(colorsRandom), 5, 20 );
    light3.add( new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( { color: color.setHex(colorsRandom) } ) ) );
    scene.add( light3 );

    light4 = new THREE.PointLight( color.setHex(colorsRandom), 5, 20 );
    light4.add( new THREE.Mesh( sphere, new THREE.MeshBasicMaterial( { color: color.setHex(colorsRandom) } ) ) );
    scene.add( light4 );

    // rectarea light

    RectAreaLightUniformsLib.init();

    const rectLight1 = new THREE.RectAreaLight( color.setHex(colorsRandom), 5, 12, 30 );
    rectLight1.position.set( - 20, 3, 20 );
    scene.add( rectLight1 );

    const rectLight2 = new THREE.RectAreaLight( color.setHex(colorsRandom2), 5, 12, 30 );
    rectLight2.position.set( 0, 3, 20 );
    scene.add( rectLight2 );

    const rectLight3 = new THREE.RectAreaLight( color.setHex(colorsRandom), 5, 12, 30 );
    rectLight3.position.set( 20, 3, 20 );
    scene.add( rectLight3 );

    scene.add( new RectAreaLightHelper( rectLight1 ) );
    scene.add( new RectAreaLightHelper( rectLight2 ) );
    scene.add( new RectAreaLightHelper( rectLight3 ) );

    // skybox

    const randomTex = ['kbcity', 'star', 'angels', 'city2', 'blue', 'grid', 'citywalk', 'flight', 'metaverse', 'strawberry', 'heart'];
    const bgTex = randomTex[Math.floor(fxrand() * randomTex.length)];

    const cubeTextureLoader = new THREE.CubeTextureLoader(managerTexture);
    cubeTextureLoader.setPath( './textures/' + bgTex + '/' );

    const cubeTexture = cubeTextureLoader.load( [
        "px.jpg", "nx.jpg",
        "py.jpg", "ny.jpg",
        "pz.jpg", "nz.jpg"
    ] );

    scene.background = cubeTexture;

    // renderer
    renderer = new THREE.WebGLRenderer( { antialias: true } );
    renderer.setSize( window.innerWidth, window.innerHeight );
    renderer.setPixelRatio( window.devicePixelRatio );
    document.body.appendChild( renderer.domElement );

    const orbitControls = new OrbitControls( camera, renderer.domElement );
    orbitControls.minDistance = 0;
    orbitControls.maxDistance = 30;
    orbitControls.enablePan = false;
    orbitControls.maxAzimuthAngle = 50;

    orbitControls.maxPolarAngle = Math.PI/2; 

    window.addEventListener( 'resize', onWindowResize, false );

    function getSkyObj() {
        return floatingObjRandom
    }
    
    function getRandomObj() {
        return randomObjRandom
    }    
    
    function getEnvObj() {
        return env2ObjRandom
    }

    function getStreetObj() {
        return envObjRandom
    }

    function getPowerUp() {
        return headObjRandom
    }

    function getBackground() {
        var bg = "";
        if (bgTex == 'angels') {
            bg = "guardian ♡ angels - https://foundation.app/@violetforest/cybertwee2077/11"
        } else if (bgTex == 'kbcity') {
            bg = "keyboard ♡ city - https://versum.xyz/token/versum/14156"
        } else if (bgTex == 'blue') {
            bg = "heart room ♡ - https://versum.xyz/token/versum/12885"
        } else if (bgTex == 'flight') {
            bg = "aerial ♡ view - https://foundation.app/@violetforest/cybertwee2077/16"
        } else if (bgTex == 'citywalk') {
            bg = "city walk ♡ - https://versum.xyz/token/versum/14111"
        } else if (bgTex == 'metaverse') {
            bg = "metaverse ☆♡ girl - https://foundation.app/@violetforest/cybertwee2077/15"
        } else if (bgTex == 'strawberry') {
            bg = "Strawberry 🍓 Angel - https://foundation.app/@violetforest/cybertwee2077/9"
        } else if (bgTex == 'fembot') {
            bg = "fembot ♥ city 2 -  https://versum.xyz/token/versum/14295"
        } else if (bgTex == 'star') {
            bg = "heart room ♡ 2 - https://versum.xyz/token/versum/25395"
        } else if (bgTex == 'heart') {
            bg = "pink fur, iridescent wings, gloss shader 🧡 - https://foundation.app/@violetforest/cybertwee2077/17"
        } else if (bgTex == 'city2') {
            bg = "angel ʚ♡ɞ city - https://versum.xyz/token/versum/25391"
        } else {
            
            bg = bgTex;
        }
        return bg
    }

    function getPlantObj() {
        return plantObjRandom
    }

    window.$fxhashFeatures = {
        "Sky ☁": getSkyObj(),
        "Powerup ☆": getPowerUp(),
        "Street ⛍": getStreetObj(),
        "Environment ⛱": getEnvObj(),
        "Plants ⚘": getPlantObj(),
        "Random 🃟": getRandomObj(),
        "Background ⍲": getBackground()
    }
}

function onWindowResize() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();

    renderer.setSize( window.innerWidth, window.innerHeight );
}

function animate() {
    requestAnimationFrame( animate );
    render();
}

function render() {
    const time = Date.now() * 0.0005;
    const delta = clock.getDelta();

    if (rotatingObj) {
        rotatingObj.rotation.y += delta * 0.9;
    }

    for ( var i = 0; i < hearts.length; i ++ ) {
        hearts[i].rotation.y += delta * 0.3 * ( i % 2 ? 1 : -1 );
    }

    light1.position.x = Math.sin( time * 0.7 ) * 30;
    light1.position.y = Math.cos( time * 0.5 ) * 40;
    light1.position.z = Math.cos( time * 0.3 ) * 30;

    light2.position.x = Math.cos( time * 0.3 ) * 30;
    light2.position.y = Math.sin( time * 0.5 ) * 40;
    light2.position.z = Math.sin( time * 0.7 ) * 30;

    light3.position.x = Math.sin( time * 0.7 ) * 30;
    light3.position.y = Math.cos( time * 0.3 ) * 40;
    light3.position.z = Math.sin( time * 0.5 ) * 30;

    light4.position.x = Math.sin( time * 0.7 ) * 30;
    light4.position.y = Math.cos( time * 0.3 ) * 40;
    light4.position.z = Math.sin( time * 0.5 ) * 30;

    renderer.render( scene, camera );
}